import React, { Component } from "react";
import { connect } from "react-redux";
import i18n from "i18next";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import KpsLayout from "./KpsLayout";
import { withRouter, Route, Switch } from "react-router-dom";
import PropertyNames from "./PropertyNames";
import LoginDialog from "./LoginDialog";
import LoggedOutDialog from "./LoggedOutDialog";
import LicenceDialog from "./LicenceDialog";
import {
  setUser,
  setDocumentTypes,
  setDocumentCategories,
  setTaxonomyTree,
  setTaxonomySuggestions,
  setTaxonomyNodeLookup,
  setMessages,
  setSettings,
  setMenu,
  addPortlet,
  setApiLocation,
  setNotifications,
  setSelectionOptions,
  setLicence,
  setApplicationProperties,
  setIsMobile,
  setGlobalAlert,
  setRunningJobs,
} from "./redux/actions/universalActions";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { Trans, withTranslation, initReactI18next } from "react-i18next";
import { SnackbarContent } from "@material-ui/core";
import translations from "./resources/loginTranslations.json";
import Typography from "@material-ui/core/Typography";
import axiosClient from "axios";
import { v4 } from "uuid";
import axios, {
  jobClient,
  contentClient,
  reportClient,
  taxServiceClient,
  discussionClient,
  authServiceClient,
  attachmentClient,
  anonAuthServiceClient,
} from "./AxiosClient";
import tokenProvider from "axios-token-interceptor";
import qs from "qs";
import PubSub from "pubsub-js";
import FormatNestedTranslations from "./FormatNestedTranslations";
import {
  MENU_PORTLET_ADD,
  HOT_TOPIC,
  HOT_TOPIC_ADD,
  HOT_TOPIC_UPDATE,
  KNOWLEDGE_ITEM_ADD,
  MENU_PORTLET_DELETE,
  MENU_PORTLET,
  MENU_PORTLET_UPDATE,
  LOGOUT,
} from "./utils/Topics.js";
import { withSnackbar } from "notistack";
import ApiHome from "./ApiHome";
import Alert from "@material-ui/lab/Alert";
import cache from "./CacheClient";
import StompFactory from "./stomp/StompFactory.js";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  textField: {
    margin: theme.spacing(1),
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  orSeparator: {
    borderBottom: "1px solid #eee",
    padding: "10px 0",
    position: "relative",
    display: "block",
    marginBottom: 25,
    fontSize: "1em",
  },
  orText: {
    position: "absolute",
    left: "43%",
    top: 0,
    background: "#fff",
    padding: 10,
    color: "rgba(0,0,0,.45)",
  },
});


export let stompClientNames = {
  jobservice: "jobservice",
  uks: "uks",
  notificationservice: "notificationservice",
  taxonomyservice:"taxonomyservice"
}
export let stompClientsContainer = {};

export class UniversalElement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasMessages: false,
      hasSettings: false,
      hasTaxonomy: false,
      hasLoggedIn: false,
      hasLicence: false,
      hasApplicationProperties: false,
      hasMenu: false,
      i18nextInitialized: false,
      isReady: false,
      apiLocation: "",
      userApiLocation: "",
      loginDialogOpen: false,
      fatalErrorDialogOpen: false,
      username: "",
      password: "",
      route: {},
      taildata: "",
      openSnack: false,
      hotTopicNumber: "",
      hotTopicMessages: null,
      taxonomy: [],
      loginError: false,
      usernameError: false,
      passwordError: false,
      userPressedLogin: false,
      numMessages: 0,
      userMessages: [],
      instance: new Date().getTime().toString(),
      documentTitle: "",
      loginProps: {},
      loggingIn: false,
      error: null,
      clearLoginFields: false,
      teamLayoutsLastUpdate: new Date().getTime(),
      apiError: false,
      userTotalMessages:0,
      userUnreadMessages:0,
      updateNotifications:0,
    };
    this._apiReady = this._apiReady.bind(this);
    this.generateTree = this.generateTree.bind(this);
    this.generateSuggestions = this.generateSuggestions.bind(this);
    // this.generateTreeNodeLookup = this.generateTreeNodeLookup.bind(this);
    this.buildNodeLookup = this.buildNodeLookup.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    let isMobile = this.getIsMobile();
    if (this.props.isMobile != isMobile) {
      this.props.setIsMobile(isMobile);
    }
    if (
      !prevProps.currentUser.requiresPasswordChange &&
      this.props.currentUser.requiresPasswordChange
    ) {
      this._showLoginForm();
    }
    if (prevState.error !== this.state.error && this.state.error) {
      this._showLoginForm();
    }
    if (this.state.userMessages !== prevState.userMessages) {
      this.props.setNotifications(this.state.userMessages);
    }
    if (this.props.userLanguage !== prevProps.userLanguage) {
      i18n.changeLanguage(this.props.userLanguage);
    }
    if (
      typeof prevState.messages === "undefined" &&
      typeof this.state.messages !== "undefined"
    ) {
      this._initi18n();
    }
    if (prevState.isReady === this.state.isReady) {
      this._isReady(
        this.state.hasMessages,
        this.state.hasMenu,
        this.state.hasLoggedIn,
        this.state.hasSettings,
        this.state.i18nextInitialized,
        this.state.hasTaxonomy,
        this.state.hasApplicationProperties,
        this.state.hasLicence,
        this.props.currentUser
      );
    }
    if (
      prevProps.location.state !== this.props.location.state &&
      this.props.location.state &&
      this.props.location.state.fromLogout
    ) {
      this._apiReady();
    }
  }

  getIsMobile = () => {
    return window.innerWidth < 600;
  };

  fetchWithTimeout = async (resource, options = {}) => {
    const { timeout = 8000 } = options;
    
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
  
    const response = await fetch(resource, {
      ...options,
      signal: controller.signal  
    });
    clearTimeout(id);
  
    return response;
  }

  // this fetches the environment variables which are defined in the docker-compose.yml. Contains runtime info specific to server environment, set in the ansible inventory file. 
  requestEnvironment = async (hostUrl)=>{
    const response = await this.fetchWithTimeout(`${hostUrl}/env`, {
      timeout: 6000
    });
    const result = await response.json();
    return result;
  }

  // this fetches the configuration, defined in the config file, set on the server. Contains runtime info specific to the client environment, set in the ansible inventory file.
  requestConfiguration = async (hostUrl)=>{
    const response = await this.fetchWithTimeout(`${hostUrl}/config`, {
      timeout: 6000
    });
    const result = await response.json();
    return result;
  }

  // tests that the api location points to a proper service. Will fail, though if gateway or authservice are not ready.
  confirmApiLocation = async (apiLocation) => {
    const response = await this.fetchWithTimeout(`https://${apiLocation}/authservice`, {
      timeout: 6000
    });
    const result = await response.json();
    return result;
  }

  confirmServices = async (hostUrl) => {
    let result = {};
    result.env= await this.requestEnvironment(hostUrl);
    result.config= await this.requestConfiguration(hostUrl);
    await this.confirmApiLocation(result.env.API_LOCATION);
    return result;
  }

  componentDidMount() {
    this.props.setIsMobile(this.getIsMobile());
    this.menuToken = PubSub.subscribe(MENU_PORTLET, this.menuSubscriber);
    this.knowledgeItemToken = PubSub.subscribe(
      KNOWLEDGE_ITEM_ADD,
      this.knowledgeItemSubscriber
    );

    this.logoutToken = PubSub.subscribe(LOGOUT, () => {
      this.setState({ isReady: false, hasLoggedIn: false }, () => {
        // this.props.history.push("/logout");
        this.logMeOut();
      });
    });
    this.setState({ messages: translations });
    axios.interceptors.response.use((res) => res, this.errorInterceptor);
    jobClient.interceptors.response.use((res) => res, this.errorInterceptor);
    contentClient.interceptors.response.use(
      (res, one) => res,
      this.errorInterceptor
    );
    reportClient.interceptors.response.use(
      (res, one) => res,
      this.errorInterceptor
    );
    taxServiceClient.interceptors.response.use(
      (res, one) => res,
      this.errorInterceptor
    );
    discussionClient.interceptors.response.use(
      (res, one) => res,
      this.errorInterceptor
    );
    authServiceClient.interceptors.response.use(
      (res, one) => res,
      this.errorInterceptor
    );
    attachmentClient.interceptors.response.use(
      (res, one) => res,
      this.errorInterceptor
    );


    let hostUrl = `https://${window.location.hostname}:8081`;
    
    //process.env is created and populated at build time.
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "production") {
      hostUrl = `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? ":" + window.location.port : ""
      }`;
    }

    this.confirmServices(hostUrl)
      .then((result)=>{
        console.log("config:");
        console.log(result.config);
        console.log("env:")
        console.log(result.env);
        this.setState({
          apiLocation: result.env.API_LOCATION,
          supportEmail: result.env.SUPPORT_EMAIL,
          env:result.env,
          config: result.config
        }, ()=>{this._apiReady()});
      })
      .catch(()=>{ 
        this.removeSpinner();
        this.setState({
          fatalErrorDialogOpen: true, // only cleared by a page reload.
          error: "UV6-1594"
        });
      });
  }



  logoutOnHTTPError = (err) => {
  
    let error = "" //this.props.t("incorrect_username_password");
    if (err.response && err.response.data) {
      if (
        err.response.data.error_description 
      ) {
        if ((err.response.data.error === "invalid_token") || (err.response.data.error === "invalid_grant")) {
          error = this.getHumanReadableError(
            err.response.data.error_description
          );
        } else {
          error = err.response.data.error_description;
        }
      } else if (err.response.data.message) {
        error = err.response.data.message;
      }
    } else if (err.message) {
      error = err.message
    }
  
    this.forceLogout(error);
  };
 
  forceLogout(message){
    this.removeStompClients(stompClientsContainer);
    let errMsg = message === "" ? null : message
    this.setState({ loggingIn: false, isReady: false, error: errMsg }, () => this._showLoginForm());
  }


 logoutOidc = (postLogoutUrl, oidcLogoutProps) => {
  if(!(oidcLogoutProps.end_session_endpoint == null)){
    const url = new URL(oidcLogoutProps.end_session_endpoint);
    if(!(oidcLogoutProps.id_token_hint==null)){
      url.searchParams.set('id_token_hint', oidcLogoutProps.id_token_hint);
    }
    if(!(oidcLogoutProps.logout_hint==null)){
      url.searchParams.set('logout_hint', oidcLogoutProps.logout_hint);
    }
    if(!(oidcLogoutProps.client_id==null)){
      url.searchParams.set('client_id', oidcLogoutProps.client_id);
    }
    url.searchParams.set('post_logout_redirect_uri', postLogoutUrl);

    console.log("logging out with: " + url.href);

    window.location.href=url.href;
  }else{
    console.log("Warning: oidc provider registration has not defined end_session_endpoint. Cannot logout current user from oidc provider.");
  }
};

clearUserAndLogin = () => {
  this.setState({ hasLoggedIn: false, loginError: false });
  this.props.setUser({});
  this.setState({ clearLoginFields: true }, () => this._showLoginForm());
}

  logMeOut = () => {
    this.removeStompClients(stompClientsContainer);
    axiosClient
      .create()({
        url: `https://${this.state.apiLocation}/authservice/logmeout/`,
        withCredentials: true,
        method: "get",
      })
      .then((res) => {
        this.clearUserAndLogin();
        if(res.data.auth_type == "oidc"){
          let url = new URL(`https://${this.state.apiLocation}`);
          //note: this URL MUST be registered as a reply url in the OIDC provider, otherwise, it will be ignored.
          let postLogoutUrl = `${url.protocol}//${url.hostname}`
          this.logoutOidc(postLogoutUrl, res.data);
        }

      })
      .catch((err) => {
        console.log("Error logging out:")
        console.log(err);
      });
  };
  onClearLoginFields = () => {
    this.setState({ clearLoginFields: false });
  };

  getHumanReadableError = (message) => {
    switch (message) {
      case "Token has been revoked":
        return this.props.t("error_token_revoked");
      case "Token has expired":
        return this.props.t("error_token_expired");
      default:
        return this.props.t("incorrect_username_password");
    }
  };

  errorInterceptor = (err) => {
    let errJson = err.toJSON();

    if(err.response){
      let statusCode = err.response.status
      if (err.response.data && err.response.data.status) {
        console.log("Server responded with status: " + err.response.status + " / " + err.response.data.status);
        statusCode = err.response.data.status
      } else {
        console.log("Server responded with status: " + err.response.status)
      }
      switch(statusCode){
        case 0:
        case 401:
          if (this.state.loginDialogOpen === false) {
            this.logoutOnHTTPError(err);
            this.setState({ hasLoggedIn: false, loginDialogOpen: true});
          }
        case 429: // too many requests  
          if (this.state.loginDialogOpen === false) {
            this.props.enqueueSnackbar(<Trans i18nKey="429_too_many_requests" />, {
              variant: "error",
              key: "api_down",
              preventDuplicate: true,
            });
          }
        break;
        case 503:
        case 404:
          if(err.response.body.includes("instance")){          
              this.props.enqueueSnackbar(<Trans i18nKey="api_down" />, {
                variant: "error",
                key: "api_down",
                preventDuplicate: true,
              });
          }
        break;
        case 403:
          //403 shouldn't log you out it means you don't have a role/permission to access something
          this.props.enqueueSnackbar(<Trans i18nKey="403_no_permission" />, {
            variant: "error",
            key: "403_no_permission",
            preventDuplicate: true,
          });
        break;    
        default: 
          console.log("errorInterceptor: NO FURTHER ACTION.");
      }
    } else {
      console.log("No response from server: Axios Error Code: " + errJson.code);
      if(errJson.code != "ERR_CANCELED"){
        this.props.enqueueSnackbar(<Trans i18nKey="api_down" />, {
          variant: "error",
          key: "api_down",
          preventDuplicate: true,
        });
      }else{
        console.log("errorInterceptor: NO FURTHER ACTION.");
      }
    }
    return Promise.reject(err);
  };

  menuSubscriber = (msg, data) => {
    switch (msg) {
      case MENU_PORTLET_ADD:
        this.props.addPortlet(data.portlet);
        break;
      case MENU_PORTLET_UPDATE:
      case MENU_PORTLET_DELETE:
        this.getMenu();
        break;
      default:
        break;
    }
  };

  knowledgeItemSubscriber = (msg, data) => {
    this.setState({ documentTitle: data.documentTitle, snackbarOpen: true });
  };

  componentWillUnmount() {
    PubSub.unsubscribe(this.menuToken);
    PubSub.unsubscribe(this.hotTopicToken);
    PubSub.unsubscribe(this.knowledgeItemToken);
    PubSub.unsubscribe(this.logoutToken);
  }

  render() {
    const { t, classes } = this.props;

    return (
      <div style={{ height: "100%" }}>
        {this.state.isReady &&
          (this.props.location &&
          this.props.location.pathname.indexOf("apidocs") > -1 ? (
            <ApiHome />
          ) : (
            <KpsLayout
              id="portal"
              messages={this.state.userMessages}
              userUnreadMessages={this.state.userUnreadMessages}
              userTotalMessages={this.state.userTotalMessages}
              teamLayoutsLastUpdate={this.state.teamLayoutsLastUpdate}
              updateNotifications={this.state.updateNotifications}
            />
          ))}

        <Switch>
          {/* <Route path="/apidocs">
            <ApiHome/>
          </Route> */}
          {/* <Route
            exact path="/logout"
          >
            <LoggedOutDialog open apiLocation={this.state.apiLocation}/>
          </Route> */}
          <Route exact path="/login/error">
            <LoginDialog
              isReady={(currentUser) => {
                this._isReady(
                  this.state.hasMessages,
                  this.state.hasMenu,
                  this.state.hasLoggedIn,
                  this.state.hasSettings,
                  this.state.i18nextInitialized,
                  this.state.hasTaxonomy,
                  this.state.hasApplicationProperties,
                  this.state.hasLicence,
                  currentUser
                );
                this._hideLoginForm();
              }}
              logoutOnHTTPError={this.logoutOnHTTPError}
              currentUser={this.props.currentUser}
              loading={this.state.loggingIn}
              open={this.state.loginDialogOpen}
              onLogin={this._performLogin}
              loginProps={this.state.loginProps}
              onUsernameUpdate={(username) => this.setState({ username })}
              onPasswordUpdate={(password) => this.setState({ password })}
              apiLocation={this.state.apiLocation}
              apiError={this.state.apiError}
              error={
                this.props.location.state
                  ? this.props.location.state.error
                  : null
              }
              clearLoginFields={this.state.clearLoginFields}
              onClearLoginFields={this.onClearLoginFields}
              t={t}
            />
          </Route>
          <Route exact path="/licence">
            <LicenceDialog open />
          </Route>
          <Route exact path="/login/admin">
            <LoginDialog
              isReady={(currentUser) => {
                this._isReady(
                  this.state.hasMessages,
                  this.state.hasMenu,
                  this.state.hasLoggedIn,
                  this.state.hasSettings,
                  this.state.i18nextInitialized,
                  this.state.hasTaxonomy,
                  this.state.hasApplicationProperties,
                  this.state.hasLicence,
                  currentUser
                );
                this._hideLoginForm();
              }}
              logoutOnHTTPError={this.logoutOnHTTPError}
              currentUser={this.props.currentUser}
              loading={this.state.loggingIn}
              open={this.state.loginDialogOpen}
              onLogin={this._performLogin}
              loginProps={this.state.loginProps}
              onUsernameUpdate={(username) => this.setState({ username })}
              onPasswordUpdate={(password) => this.setState({ password })}
              apiLocation={this.state.apiLocation}
              isBackdoor
              clearLoginFields={this.state.clearLoginFields}
              onClearLoginFields={this.onClearLoginFields}
              t={t}
            />
          </Route>
          <Route path="/">
            <LoginDialog
              isReady={(currentUser) => {
                this._isReady(
                  this.state.hasMessages,
                  this.state.hasMenu,
                  this.state.hasLoggedIn,
                  this.state.hasSettings,
                  this.state.i18nextInitialized,
                  this.state.hasTaxonomy,
                  this.state.hasApplicationProperties,
                  this.state.hasLicence,
                  currentUser
                );
                this._hideLoginForm();
              }}
              logoutOnHTTPError={this.logoutOnHTTPError}
              currentUser={this.props.currentUser}
              loading={this.state.loggingIn}
              open={this.state.loginDialogOpen}
              onLogin={this._performLogin}
              loginProps={this.state.loginProps}
              onUsernameUpdate={(username) => this.setState({ username })}
              onPasswordUpdate={(password) => this.setState({ password })}
              apiLocation={this.state.apiLocation}
              apiError={this.state.apiError}
              error={
                this.state.error ? this.state.error : this.state.loginError
              }
              clearLoginFields={this.state.clearLoginFields}
              onClearLoginFields={this.onClearLoginFields}
              t={t}
            />
          </Route>
        </Switch>

        <Dialog
          open={this.state.fatalErrorDialogOpen}
          aria-labelledby="error-dialog-title"
          aria-describedby="api-dialog-description"
        >
          <DialogTitle id="error-dialog-title">:-(</DialogTitle>
          <DialogContent id="error-dialog-description">
          <p><b>{this.state.error}</b></p>
          </DialogContent>
        </Dialog>

        <Snackbar
          open={this.state.openSnack}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          onClose={this.handleCloseSnack}
          id="hotTopicSnack"
          message={t("new_message")}
          action={
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.handleCloseSnack}
            >
              <CloseIcon />
            </IconButton>
          }
        />

        <Snackbar
          open={this.state.snackbarOpen}
          autoHideDuration={6000}
          onClose={this.handleCloseSnackGlobal}
        >
          <SnackbarContent
            action={
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleCloseSnackGlobal}
              >
                <CloseIcon />
              </IconButton>
            }
            message={
              <div>
                {t("new_managed_document")}{" "}
                <Typography display="inline" color="primary">
                  {this.state.documentTitle}
                </Typography>{" "}
                {t("new_managed_document_two")}
              </div>
            }
          />
        </Snackbar>
        <Snackbar open={this.props.globalAlert.open} 
          autoHideDuration={6000} 
          onClose={this.handleGlobalAlertClose}
        > 
          <Alert severity={this.props.globalAlert.type} >{t(this.props.globalAlert.message)}</Alert>
        </Snackbar>    
      </div>
    );
  }
  handleGlobalAlertClose = () =>{
    this.props.setGlobalAlert({...this.props.globalAlert, open: false})
  }
  handleCloseSnackGlobal = () => {
    this.setState({ snackbarOpen: false });
  };
  handleCloseSnack = () => {
    this.setState({ openSnack: false });
  };

  handleCloseLoginErrorSnack = () => {
    this.setState({ loginError: false });
  };

  _isReady = (
    hasMessages,
    hasMenu,
    hasLoggedIn,
    hasSettings,
    i18nextInitialized,
    hasTaxonomy,
    hasApplicationProperties,
    hasLicence,
    currentUser
  ) => {
    if (
      hasMessages &&
      hasMenu &&
      hasLoggedIn &&
      hasSettings &&
      hasTaxonomy &&
      i18nextInitialized &&
      hasApplicationProperties &&
      hasLicence &&
      !currentUser.requiresPasswordChange &&
      !this.state.isReady
    ) {
      this.removeSpinner();
      this.setState({ isReady: true, error: null, apiError: false });
    }
  };
  _initi18n = () => {
    i18n
      .use(new FormatNestedTranslations())
      .use(initReactI18next)
      .init(
        {
          lng: "en_GB",
          debug: false,
          resources: this.state.messages,
          postProcess: ["postProcessorNested"],
          fallbackLng: "en_GB",
          keySeparator: false,
        },
        () => {
          this.setState({ i18nextInitialized: true });
        }
      );
  };

  _apiReady() {
    this.props.setApiLocation(this.state.apiLocation);
    // let parsed = psl.parse(window.location.hostname);
    anonAuthServiceClient
      .get("/property/login/", {
        params: {
          organization: "demo",
        },
      })
      .then((res) => {
        this.setState({ loginProps: res.data }, () => {
        this.hasLoginProperties();
        });
      })
      .catch((err) => {
       this.hasLoginProperties();
      });
  }

  hasLoginProperties = () => {
    this.tryLogin();
  };


  _showLoginForm = () => {
    this.setState({ loginDialogOpen: true });
    this.removeSpinner();
  };

  removeSpinner = () => {
    if (document.getElementById("loader")) {
      var s = document.getElementById("loader").style;
      s.opacity = 1;
      (function fade() {
        (s.opacity -= 0.1) < 0 ? (s.display = "none") : setTimeout(fade, 20);
      })();
    }
  };

  _hideLoginForm = () => {
    this.setState({ loginDialogOpen: false });
  };

  _performLogin = (username, password) => {
    // this.tryLogin();
    this.postForToken()
      .then(() => {
        this.postLoginTasks();
      })
      .catch((err) => {
        // token was invalid or credentials were incorrect so we need to completely reauth
        // and get a new token
        this.logoutOnHTTPError(err);
      });
  };
  postLoginTasks = () => {
    taxServiceClient
      .get("/user/loggedin/", { withCredentials: true })
      .then((res) => {
        this.setState({ loggingIn: false });
        if (
          this.props.location.pathname === "/login/admin" ||
          this.props.location.pathname === "/login/error"
        ) {
          this.props.history.push("/");
        }
        !res.data.requiresPasswordChange && this._hideLoginForm();
        this.props.setUser(res.data);

        if (
          res.data.avatarURI != null &&
          res.data.avatarURI != "" &&
          res.data.avatarURI !== "images/defaultAvatar.jpg"
        ) {
          let cached = cache.get(`attachment-${res.data.avatarURI}`);
          if(!cached){
          attachmentClient
            .get(`/attachment/${res.data.avatarURI}/content/`, {
              responseType: "blob",
              withCredentials: true,
            })
            .then((response) => {
              let reader = new FileReader();
              reader.readAsDataURL(response.data);
              reader.onloadend = () => {
                let base64data = reader.result;
                this.props.setUser({
                  ...res.data,
                  avatarBase64: base64data,
                });
                cache.put(`attachment-${res.data.avatarURI}`, base64data);
              };
            })
            .catch((err) => {
              this.props.enqueueSnackbar("Error retrieving avatar", {
                variant: "error",
              });
            });
          } else {
            this.props.setUser({
              ...res.data,
              avatarBase64: cached,
            });
          }
        }

        this.setState({
          hasLoggedIn: true,
          loginError: false,
          apiError: false,
        });
        if (!this.state.hasMessages) {
          this._getMessages();
        }
        this.getApplicationProperties();
        this._getDocumentTypes();
        this.getDocumentCategories();
        this.getTaxonomy();
        this.getSelectionOptions();
        this.getHotTopics();
        this.getRequiredReadingNotifications();
        this.getMenu();
        this.getSettings();
        this.getLicence();
        this.createStompClients(stompClientsContainer, this.state.apiLocation, this.state.config.stomp);
      })
      .catch((err) => {
        // token was invalid or credentials were incorrect so we need to completely reauth
        // and get a new token
        console.log(err);
        //this.logoutOnHTTPError(err);
        this.setState({ loggingIn: false, isReady: false});
        this._showLoginForm();
        // this.setState({loginDialogOpen: true})
      });
  };
  tryLogin = () => {
    this.setState({ loggingIn: true, loginError: false, apiError: false });
    this.postLoginTasks();
  };

  getLicence = () => {
    authServiceClient
      .get("/licence/current", { withCredentials: true })
      .then((res) => {
        this.props.setLicence(res.data);
        this.setState({ hasLicence: true });
      })
      .catch(() => {
        this.state.error === null &&
        this.setState({ error: "error_licence_request" });
      });
  };


  removeStompClients = (container)=>{
    let promises = [];
    Object.keys(container).forEach((key,index)=>{
      let client = container[key];
      delete container[key];
      console.log("deactivating: " + client.brokerURL);
      promises.push(client.deactivate());
    });
    Promise.all(promises);  
  }


  // see UV6-1581 

  createStompClients = (container, apiLocation, config) => {
    
    console.log("Creating Stomp clients.")
    console.log("Stomp: Heartbeat Authentication: enabled: " + config.authentication.enabled);
    console.log("Stomp: Logout on closure enabled: " + config.logout_on_closure.enabled);
    console.log("Stomp: closures before logout: " + config.logout_on_closure.closures_before_logout);
    console.log("Stomp: Shared worker enabled: " + config.shared_worker.enabled);


    let firstTimeLatch=false;
    let self=this;

    function handleConnection(key,client){
      console.log("client connected: " + key);
    }     

    function handleUnrecoverableWSError(client){ 
        if(!firstTimeLatch){
          console.log("Attempting logout");                  
          firstTimeLatch = true;
          self.forceLogout("");
        }else{
          console.log("STOMP handler latched. No further action until login")
        }
    }

    
    function createStompClient(
      config,
      toConnect, 
      toSubscribe,
      toPublish, 
      onConnect, 
      onMessage, 
      onUnrecoverableWebSocketError){

      // closure codes https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent/code
      const WSCODE = {
        FIRST_VALID: 1000,
        NORMAL: 1000, // The connection successfully completed the purpose for which it was created.
        GOING_AWAY: 1001, // The endpoint is going away, either because of a server failure or because the browser is navigating away from the page that opened the connection.
        PROTOCOL_ENDPOINT: 1002, // Protocol error Endpoint received malformed frame
        UNSUPPORTED_DATA: 1003, // The connection is being terminated because the endpoint received data of a type it cannot accept. (For example, a text-only endpoint received binary data.)
        RESERVED_1: 1004, // 	Reserved. A meaning might be defined in the future.
        NO_STATUS_RECEIVED:1005, // transport layer finished normally (e.g. TCP FIN but no previous CLOSE frame)
        ABNORMAL: 1006, // Abnormal Closure Transport layer broke (e.g. couldn't connect, TCP RST)
        INVALID_FRAME_PAYLOAD: 1007, // The endpoint is terminating the connection because a message was received that contained inconsistent data (e.g., non-UTF-8 data within a text message).
        POLICY_VIOLATION: 1008, // The endpoint is terminating the connection because it received a message that violates its policy. This is a generic status code, used when codes 1003 and 1009 are not suitable.
        MESSAGE_TOO_BIG: 1009, // The endpoint is terminating the connection because a data frame was received that is too large.
        MANDATORY_EXT: 1010, // 	The client is terminating the connection because it expected the server to negotiate one or more extension, but the server didn't.
        INTERNAL_ERROR: 1011, // The server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.
        SERVICE_RESTART: 1012, 	//The server is terminating the connection because it is restarting.
        TRY_AGAIN_LATER: 1013, // The server is terminating the connection due to a temporary condition, e.g., it is overloaded and is casting off some of its clients.
        BAD_GATEWAY: 1014, // The server was acting as a gateway or proxy and received an invalid response from the upstream server. This is similar to 502 HTTP Status Code.
        TLS_HANDSHAKE: 1015, // Indicates that the connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified).
        LAST_VALID: 1015
      }
    
      // handle KPS STOMP errors which on authentication failure. Immediate logout.
      // otherwise, stay logged-in allow to retry
      const isAuthEnabled =  config.authentication.enabled;

      // try to diagnose reason for closure. Logout if necessary
      // otherwise, stay logged-in and allow to retry.
      const isLogoutOnClosureEnabled = config.logout_on_closure.enabled;
      const closuresBeforeLogout = config.logout_on_closure.closures_before_logout;
      let closuresLeft=closuresBeforeLogout;

      // if a websocket closure is preceded by an unexpected STOMP error
      // treat as unrecoverable.
      let hasUnexpectedSTOMPError = false;

      // closure code falls outside supported closure definitions 
      const onUnknownCode = (code)=>{
          // we're using 'unknown' codes in the SharedWorker version
          // we'll treat these as universally fatal.
          console.log("unknown:", code);
          onUnrecoverableWebSocketError(client, code);            
      }

      // closure code requires logout
      const onUrgentCode = (code)=>{
        if(isLogoutOnClosureEnabled){
          console.log("urgent:" + code);
          onUnrecoverableWebSocketError(client, code);            
        }
      }

      // closure code means reason is ambiguous and may be temporary 
      const onCountdownableCode = (code)=>{
        if(isLogoutOnClosureEnabled){
          console.log("countdownable:", code);
          if(!hasUnexpectedSTOMPError){
            console.log("closures left before logout: " + closuresLeft );
            if(closuresLeft > 0 ){
              closuresLeft -= 1;
              console.log(`retrying in: ${client.reconnectDelay / 1000}s`,);
            }else{
              onUnrecoverableWebSocketError(client, code);
            }
          }else{
            console.log("with unexpected STOMP error"); 
            onUnrecoverableWebSocketError(client, code);
          }
        }
      }

      // closure code means reason is OK to retry.
      const onIgnorableCode = (code) => {
        if(isLogoutOnClosureEnabled){
          console.log("ignorable: " + code);
          console.log(`retrying in: ${client.reconnectDelay / 1000}s`);
          if(hasUnexpectedSTOMPError){
            console.log("with unexpected STOMP error");
            onUnrecoverableWebSocketError(client, code);            
          }
        }
      }

      const client = StompFactory.createClient(
        {
          brokerURL:toConnect,
          heartbeatIncoming: config.heartbeat_s * 1000,
          heartbeatOutgoing: config.heartbeat_s * 1000,
          connectionTimeout:  (config.heartbeat_s + 1) * 1000,
          reconnectDelay: config.retry_delay_s * 1000, 

          beforeConnect: ()=>{
            console.log("websocket connecting: " + client.brokerURL);
          },           
          onConnect:()=>{
            client.subscribe(
              toSubscribe,
              (frame)=>{
                if (frame.command === "MESSAGE") {
                  onMessage(frame);
                }
              });
            if(toPublish){
              client.publish({destination: toPublish});
            }
            closuresLeft=closuresBeforeLogout;
            hasUnexpectedSTOMPError = false;
            onConnect(client);
          },
          onWebSocketClose: (evt)=>{
            let code = evt.code;
            console.log(`websocket closed. Code: ${code}  at: ${client.brokerURL}.`);
            
            if(code < WSCODE.FIRST_VALID || evt > WSCODE.LAST_VALID){
              // unknown errors - we don't really know what to do with these, so they have their own policy.
              onUnknownCode(code);
            }else{
              switch(code){
                // codes for which we know we would benefit from having the user logout.
                case WSCODE.NORMAL: 
                case WSCODE.UNSUPPORTED_DATA:
                case WSCODE.RESERVED_1:
                case WSCODE.POLICY_VIOLATION: 
                case WSCODE.MANDATORY_EXT: 
                case WSCODE.INTERNAL_ERROR:
                case WSCODE.TRY_AGAIN_LATER:
                case WSCODE.BAD_GATEWAY: 
                case WSCODE.TLS_HANDSHAKE:
                onUrgentCode(code);
                break;

                // codes for which we will retry conditionally, as they are ambiguous, and may mean service down (temporary) or token expiry (needs logout) 
                case WSCODE.PROTOCOL_ENDPOINT:
                case WSCODE.ABNORMAL:
                case WSCODE.SERVICE_RESTART: 
                onCountdownableCode( code);
                break;
                // codes for which we can absolutely keep re-connecting indefinitely
                case WSCODE.NO_STATUS_RECEIVED: 
                case WSCODE.GOING_AWAY: // for a shared websocket, this would mean a different tab may be tasking away
                case WSCODE.INVALID_FRAME_PAYLOAD: // assume will not be retransmitted.
                case WSCODE.MESSAGE_TOO_BIG: // assume will not be retransmitted
                onIgnorableCode(code);
                break;
              }
            }
          },
          onWebSocketError: (evt)=>{
            console.log("websocket error at: " + client.brokerURL);
          },
          onStompError: (frame)=>{
          
            console.log("STOMP protocol error at: " + client.brokerURL);
            let isAuthError = false;
            
            try{
              // AUTHENTICATION_FAILED is a string we place in a runtime exception thrown in the remote service's StompInboundAuthInterceptor
              // The Spring framework catches the exception, creates and sends an ERROR message, and then closes the websocket.
              isAuthError=frame.headers.message.includes("AUTHENTICATION_FAILED");
            }catch(e){}      
            
            if (isAuthError){
              if(isAuthEnabled){
                onUnrecoverableWebSocketError(client);
              }else{
                console.log("Ignoring STOMP authentication error.")
              }
            }else{
              // we can get this event when there is an overload of the gateway, or service.
              // to get a stomp error, the websocket handling the protocol must be connected  
              console.log("Unexpected STOMP error. Message: \n" + frame.headers.message);
              hasUnexpectedSTOMPError=true;
            }
          } 
        },
        config.shared_worker.enabled 
       );
       client.activate();
       return client;
    }

    

    // jobservice
    if(!container[stompClientNames.jobservice]){
      console.log("creating jobservice STOMP");
      container[stompClientNames.jobservice] = createStompClient(
        config,
        `wss://${apiLocation}/jobservice/secured/job`,
        "/topic/job",
        null,
        (client)=>{ handleConnection(stompClientNames.jobservice ,client) },
        this.handleJobWebsocketFrame,
        (client)=>{ handleUnrecoverableWSError(client)}
      );
    }else{
      console.log("jobservice client already exists.");
    }      
    


    // taxonomyservice
    if(!container[stompClientNames.taxonomyservice]){
      console.log("creating taxonomyservice STOMP");
      container[stompClientNames.taxonomyservice] = createStompClient(
       config,
       `wss://${apiLocation}/taxonomyservice/secured/taxonomy`,
       "/user/queue/taxonomy",
       null,
       (client)=>{ handleConnection(stompClientNames.taxonomyservice,client)},
       this.handleWebsocketFrame,
       (client)=>{ handleUnrecoverableWSError(client)}
      );
    }else{
      console.log("taxonomyservice client already exists.");
    }      

    // uks 
    if(!container[stompClientNames.uks]){
      console.log("creating uks STOMP");
      container[stompClientNames.uks] = createStompClient(
       config,
       `wss://${apiLocation}/uks/secured/uks`,
       "/topic/documenttypes",
       null,
       (client)=>{ handleConnection(stompClientNames.uks,client)},
       this.handleDocumentTypeWebsocketFrame,
       (client)=>{ handleUnrecoverableWSError(client)}
      );
    }else{
      console.log("uks client already exists.");
    }

    // notificationservice
    if(!container[stompClientNames.notificationservice]){
      console.log("creating notificationservice STOMP");
      container[stompClientNames.notificationservice] = createStompClient(
       config,
       `wss://${apiLocation}/notificationservice/secured/notifications`,
       "/user/queue/notifications",
       "/app/notifications",
       (client)=>{ handleConnection(stompClientNames.notificationservice,client)},
       this.handleWebsocketFrame,
       (client)=>{ handleUnrecoverableWSError(client)}
      );   
    }else{
      console.log("notificationservice client already exists.");
    }
     
  }

  handleDocumentTypeWebsocketFrame = (frame) => {
    let message = JSON.parse(frame.body);
    let isUpdate =
      this.props.documentTypes.filter(
        (type) => type.documentTypeID === message.documentTypeID
      ).length > 0;
    if (isUpdate) {
      let updated = this.props.documentTypes.map((type) => {
        if (type.documentTypeID === message.documentTypeID) {
          return message;
        }
        return type;
      });
      this.props.setDocumentTypes(updated);
    } else {
      // new doc type
      this.props.setDocumentTypes([...this.props.documentTypes, message]);
    }
  };

  handleJobWebsocketFrame = (frame) => {
    let message = JSON.parse(frame.body);
    let isUpdate =
      Array.isArray(this.props.runningJobs) &&
      this.props.runningJobs.filter(
        (job) => job.sourceId === message.sourceId
      ).length > 0;
    if (isUpdate) {
      let updated = this.props.runningJobs.map((job) => {
        if (job.sourceId === message.sourceId) {
          return message;
        }
        return job;
      });
      this.props.setRunningJobs(updated);
    } else {
      Array.isArray(this.props.runningJobs) 
        ? this.props.setRunningJobs([...this.props.runningJobs, message])
        : this.props.setRunningJobs([message])
    }
  };

  handleWebsocketFrame = (frame) => {
    let message = JSON.parse(frame.body);
    if (message.hasOwnProperty("total") && message.hasOwnProperty("unread") ) {
      this.setState({userTotalMessages:message.total,
      userUnreadMessages:message.unread,});
    }
      if (message.messageType === "NOTIFICATION") {
        this.props.enqueueSnackbar(<Trans i18nKey="new_message" />, {
          variant: "info",
        });
        this.setState({userTotalMessages:this.state.userTotalMessages + 1,
          userUnreadMessages:this.state.userUnreadMessages + 1,});
      } else if (message.messageType === "READ_NOTIFICATION") {
        // mark it as read
        this.setState({userUnreadMessages:this.state.userUnreadMessages - 1,});
      } else if (message.messageType === "UPDATE_MESSAGE") {
        // update the message
      } else if (message.messageType === "DELETE_NOTIFICATION") {
        // remove it
        if(!message.isViewed){
          this.setState({userUnreadMessages:this.state.userUnreadMessages - 1,});
        }
        this.setState({userTotalMessages:this.state.userTotalMessages - 1,});
        this.setState({updateNotifications:this.state.updateNotifications + 1,});
      } else if (message.messageType === "DELETE_ALL_NOTIFICATIONS") {
        // clear all
        this.setState({ userUnreadMessages: 0, userTotalMessages: 0 });
      } else if (message.messageType === "READ_ALL_NOTIFICATIONS") {
        // read all
        this.setState({ userUnreadMessages:0 });
        this.setState({updateNotifications:this.state.updateNotifications + 1,});
      } else if (message.messageType === "UPDATE_TAXONOMY") {
        this.getTaxonomy();
      } else if (message.messageType === "UPDATE_TEAM_LAYOUT") {
        this.setState({ teamLayoutsLastUpdate: new Date().getTime() });
      }
  };

  getNumUnreadNotifications = (messages) => {
    return messages.filter((m) => !m.isViewed).length;
  };

  getMenu = () => {
    axios
      .get("/menuportlet/", { withCredentials: true })
      .then((res) => {
        this.props.setMenu(
          res.data.map((ele) => {
            if (ele.parameters === null) ele.parameters = "{}";
            // if (this.props.isMobile && ele.id === 1001) {
            return {
              ...ele,
             // parameters: JSON.parse(ele.parameters),
            };
            // }
          }),
          1
        );
        this.setState({ hasMenu: true });
      })
      .catch(() => {
        this.state.error === null &&
        this.setState({ error: "error_menu_portlet_request" });
      });
  };

  getApplicationProperties = () => {
    axios
      .get("/application-property/", { withCredentials: true })
      .then((res) => {
        this.props.setApplicationProperties(res.data);
        this.setState({ hasApplicationProperties: true });
      })
      .catch(() => {
        this.state.error === null &&
        this.setState({ error: "error_application_properties_request" });
      });
  };

  getSettings = () => {
    this.setState({ hasSettings: true }); // axios
    //   .get("/property/")
    //   .then((res) => {
    //     this.props.setSettings(res.data);
    //   })
    //   .catch(() => {
    //     this.setState({ error: "error_property_request" });
    //   });
  };

  postForToken = () => {
    let organization = "demo";
    return new Promise((resolve, reject) => {
      axiosClient
        .create()({
          url: `https://${this.state.apiLocation}/authservice/oauth/token`,
          withCredentials: true,
          method: "post",
          data: qs.stringify({
            grant_type: "org_password",
            username: this.state.username,
            password: this.state.password,
            scope: "read write",
            organization,
          }),
        })
        .then((res) => {
          resolve();
        })
        .catch((err) => {
          this.setState(
            {
              apiError: !err.response,
              error:
                err.response &&
                err.response.data &&
                err.response.data.error_description
                  ? err.response.data.error_description
                  : err.isAxiosError && err.isAxiosError === true && err.message
                    ? err.message
                    : null,
            },
            () => {
              this._showLoginForm();
            }
          );
          reject(err);
        });
    });
  };

  _getMessages = () => {
    axios
      .get("/i18n/bundled", { withCredentials: true })
      .then((res) => {
        if (!this.state.hasMessages) {
          this.setState({ hasMessages: true });
          var tmpMessages = {};
          res.data.bundles.forEach((element) => {
            tmpMessages[element.locale] = {};
            tmpMessages[element.locale].translation = element.messages;
          });
          this.setState({ messages: tmpMessages }, () => {
            this._initi18n();
          });
        }
      })
      .catch(() => {
        this.state.error === null &&
        this.setState({ error: "error_i18n_bundled_request" });
      });

    axios.get("/i18n/", { withCredentials: true }).then((res) => {
      this.props.setMessages(res.data);
    });
  };

  _getDocumentTypes = () => {
    axios.get("/documenttype/", { withCredentials: true }).then((res) => {
      this.props.setDocumentTypes(res.data);
    });
  };

  getDocumentCategories = () => {
    axios.get("/document-category", { withCredentials: true }).then((res) => {
      this.props.setDocumentCategories(res.data);
    });
  };

  getSelectionOptions = () => {
    axios.get("/selectionoptions/", { withCredentials: true }).then((res) => {
      this.props.setSelectionOptions(res.data);
    });
  };

  getRequiredReadingNotifications = () => {
    // TODO
    // axios.post("/requiredreading/alerted",{}).then(res => {
    //   this.setState({
    //     numMessages: res.data.content.length,
    //     userMessages: [...this.state.userMessages, ...res.data.content]
    //   });
    // });
  };

  getHotTopics = () => {
    // axios.get("/hottopic/user/").then(res => {
    //   this.setState({
    //     numMessages: res.data.content.length,
    //     userMessages: res.data.content
    //   });
    // });
  };

  getTaxonomy = () => {
    taxServiceClient
      .get("/taxonomy/user/", { withCredentials: true })
      .then((res) => {
        this.props.setTaxonomyTree(res.data);
        this.props.setTaxonomySuggestions(this.generateSuggestions(res.data));
        this.props.setTaxonomyNodeLookup(
          // this.generateTreeNodeLookup({}, res.data)
          this.buildNodeLookup(res.data, [])
        );
        this.setState({ taxonomy: res.data, hasTaxonomy: true });
      })
      .catch(() => {
        this.state.error === null &&
        this.setState({ error: "error_taxonomy_request" });
      });
  };

  generateSuggestions = (tree) => {
    if (!tree || tree.length === 0) {
      return [];
    }
    let suggestions = [];

    let treechildren = tree.children ? tree.children : [];
    let treename = tree.name;
    if (tree.tax) {
      treechildren = tree.tax.children;
      treename = tree.tax.name;
    }
    suggestions.push({ label: treename, node: tree });
    treechildren.forEach((element) => {
      suggestions = suggestions.concat(this.generateSuggestions(element));
    });

    return suggestions;
  };

  generateTree = (tree) => {
    if (!tree || tree.length === 0) {
      return [];
    }

    let treename = tree.name;
    tree.collapsed = false;
    let children = [];
    let treechildren = tree.children;
    if (tree.tax) {
      treechildren = tree.tax.children;
      treename = tree.tax.name;
    }
    tree.module = treename;
    treechildren.forEach((element) => {
      children.push(this.generateTree(element));
    });
    tree.children = children;

    return tree;
  };
  // generateTreeNodeLookup = (lookup, tree) => {
  //   if (!tree || tree.length === 0) {
  //     return [];
  //   }

  //   let nodename = tree.name;
  //   let nodeid = tree.object == null ?
  //     tree.id : tree.object.hasOwnProperty("topicId") ? tree.object.topicId : tree.id;
  //   let children = [];
  //   let treechildren = tree.children;
  //   if (tree.tax) {
  //     treechildren = tree.tax.children;
  //     nodename = tree.tax.name;
  //     nodeid = tree.tax.id;
  //   }
  //   lookup[nodeid] = nodename;
  //   treechildren.forEach(element => {
  //     lookup = this.generateTreeNodeLookup(lookup, element);
  //   });

  //   return lookup;
  // };
  buildNodeLookup = (node, lookup) => {
    lookup.push(node);
    if (node.children) {
      node.children.forEach((child) => this.buildNodeLookup(child, lookup));
    }
    return lookup;
  };
}
const mapStateToProps = (state) => ({
  message: state.websocket.message,
  userLanguage: state.user.language,
  currentUser: state.user.currentUser,
  documentTypes: state.prefs.documentTypes,
  runningJobs: state.admin.runningJobs,
  isMobile: state.screen.isMobile,
  globalAlert: state.globalAlert,
});
const mapDispatchToProps = {
  setUser,
  setDocumentTypes,
  setRunningJobs,
  setDocumentCategories,
  setTaxonomyTree,
  setTaxonomySuggestions,
  setTaxonomyNodeLookup,
  setMessages,
  setSettings,
  setMenu,
  addPortlet,
  setApiLocation,
  setSelectionOptions,
  setNotifications,
  setApplicationProperties,
  setLicence,
  setIsMobile,
  setGlobalAlert,
};
export default withTranslation()(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(withStyles(styles)(withSnackbar(UniversalElement)))
  )
);
